export const DEVICES_REPORT_KEY = () => removeUndefined(['devices-reports'])
export const GUARANTEES_PART_INFO_KEY = () => removeUndefined(['guarantees-part-info'])
export const PARTS_KEY = () => removeUndefined(['parts'])
export const INVENTORY_STATUS_KEY = () => removeUndefined(['inventory'])
export const AVAILABLE_MODELS_KEY = (owner) => removeUndefined(['available', owner])
export const AVAILABLE_STATUS_KEY = () => removeUndefined([`available`])
export const BRANDS_KEY = () => removeUndefined(['brands'])
export const MODELS_KEY = () => removeUndefined(['models'])
export const COLOR_KEY = () => removeUndefined(['colors'])
export const PROFORMAS_KEY = (onlyActives = true, page = 0) => removeUndefined(['proformas', onlyActives, page])
export const INVOICES_KEY = (onlyNotDelivered, page) => removeUndefined(['invoices', onlyNotDelivered, page])
export const PROFORMA_DETAILS_KEY = (id) => removeUndefined(['proforma', id])
export const INVOICE_DETAILS_KEY = (id) => removeUndefined(['invoice', id])
export const INVOICE_ROW_STATUS_KEY = (id) => removeUndefined(['invoice-stats', id])
export const FIRMS_KEY = (subsidary) => removeUndefined(['firms', subsidary])
export const BANK_ACCOUNTS_KEY = (id) => removeUndefined(['bank-accounts', id])
export const PROFILE_KEY = () => removeUndefined(['profile'])
export const USER_KEY = (id) => removeUndefined(['profile', id])


const removeUndefined = arr => arr.filter(x => x !== undefined)